import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class SrChecklistService {
    constructor(private readonly datatask: DataTaskService) {}

    /** @datatask 1779 */
    public async getCrewChange(params: SrCheckListParams): Promise<SrCheckListCrewChangeGet> { return (await this.datatask.Post(1779, params))[0]; }
    /** @datatask 1780 */
    public getCrewChanges(page: SrCheckListCrewChangeGet): Promise<SrCheckListCrewItem[]> { return this.datatask.Post(1780, page); }
    /** @datatask 1781 */
    public async saveCrewChange(page: SrCheckListCrewChangeSave): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1781, page))[0]; }
    /** @datatask 1631 */
    public async getCrews(params: SrCheckListParams): Promise<SrCheckListCrewsGet> { return (await this.datatask.Post(1631, params))[0]; }
    /** @datatask 1782 */
    public getCrewList(params: SrCheckListParams): Promise<Item[]> { return this.datatask.Post(1782, params); }
    /** @datatask 1799 */
    public async getEquipment(params: SrCheckListEquipmentParams): Promise<SrCheckListEquipmentGet> { return (await this.datatask.Post(1799, params))[0]; }
    /** @datatask 1800 */
    public getEquipmentChoices(params: SrCheckListEquipmentChoicesParams): Promise<SrCheckListEquipmentItem[]> { return this.datatask.Post(1800, params); }
    /** @datatask 1802 */
    public async saveEquipment(page: SrCheckListEquipmentGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1802, page))[0]; }
    /** @datatask 1804 */
    public async deleteEquipment(page: SrCheckListEquipmentGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1804, page))[0]; }
    /** @datatask 1798 */
    public async getEquipments(params: SrCheckListEquipmentsParams): Promise<SrCheckListEquipmentsGet> { return (await this.datatask.Post(1798, params))[0]; }
    /** @datatask 1803 */
    public getEquipmentList(page: SrCheckListEquipmentsGet): Promise<Item[]> { return this.datatask.Post(1803, page); }
    /** @datatask 1806 */
    public async getExpense(params: SrCheckListRefundParams): Promise<SrCheckListExpenseGet> { return (await this.datatask.Post(1806, params))[0]; }
    /** @datatask 1807 */
    public async saveExpense(page: SrCheckListExpenseGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1807, page))[0]; }
    /** @datatask 1805 */
    public async getExpenses(params: SrCheckListParams): Promise<SrCheckListExpensesGet> { return (await this.datatask.Post(1805, params))[0]; }
    /** @datatask 1808 */
    public getExpenseList(params: SrCheckListParams): Promise<Item[]> { return this.datatask.Post(1808, params); }
    /** @datatask 1811 */
    public async getLossDamage(params: SrCheckListRefundParams): Promise<SrCheckListLdGet> { return (await this.datatask.Post(1811, params))[0]; }
    /** @datatask 1812 */
    public async saveLossDamage(page: SrCheckListLdGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1812, page))[0]; }
    /** @datatask 1813 */
    public async deleteLossDamage(page: SrCheckListLdGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1813, page))[0]; }
    /** @datatask 1809 */
    public async getLossDamages(params: SrCheckListParams): Promise<SrCheckListLdsGet> { return (await this.datatask.Post(1809, params))[0]; }
    /** @datatask 1810 */
    public getLossDamageList(params: SrCheckListParams): Promise<Item[]> { return this.datatask.Post(1810, params); }
}

export interface SrCheckListParams { checklistdata_keyno: string; }
export interface SrCheckListRefundParams extends SrCheckListParams { srrefundinput_keyno: string; }
export interface SrCheckListEquipmentsParams extends SrCheckListParams { srrefundtype_id: string; }
export interface SrCheckListEquipmentParams extends SrCheckListRefundParams { srrefundtype_id: string; }
export interface SrCheckListEquipmentChoicesParams extends SrCheckListEquipmentParams { resource_id: string; }
export interface SrCheckListPageGet extends SrCheckListParams { page_heading: string; resource_name: string; }
export interface SrCheckListCrewsGet extends SrCheckListPageGet { resource_id: string; }
export interface SrCheckListCrewChangeGet extends SrCheckListCrewsGet {
    bg_srchecklistcrewchange_main: string;
    signin_dt: string;
    signin_dt_helptext: string;
    signout_dt: string;
    signout_dt_helptext: string;
    searchtext: string;
}
export interface SrCheckListCrewItem extends Item { item_id: string; item_is_selected: '0' | '1'; }
export interface SrCheckListCrewSelection { item_id: string; item_is_selected: '0' | '1'; }
export interface SrCheckListCrewChangeSave extends SrCheckListCrewChangeGet { records: SrCheckListCrewSelection[]; }
export interface SrCheckListEquipmentItem { srequipment_keyno: string; srequipment_name: string; }
export interface SrCheckListEquipmentsGet extends SrCheckListPageGet, SrCheckListEquipmentsParams { srequipment_type: string; }
export interface SrCheckListEquipmentGet extends SrCheckListPageGet, SrCheckListEquipmentChoicesParams {
    srequipment_type: string;
    important_helptext: string;
    srequipment_keyno: string;
    hours_total: string | number;
    hours_total_helptext: string;
    nbr_of_days: string | number;
    nbr_of_days_helptext: string;
    show_equipment_km: '0' | '1';
    equipment_km: string | number;
    equipment_km_helptext: string;
    show_roadtoll: '0' | '1';
    roadtoll_has: '0' | '1';
    roadtoll_amount: string | number;
    roadtoll_note: string;
    show_plane_flightlog: '0' | '1';
    plane_flightlog: string;
    hours_postwork: string | number;
    show_button_pictures: '0' | '1';
    show_button_documents: '0' | '1';
    nbr_of_pictures: string | number;
    nbr_of_documents: string | number;
}
export interface SrCheckListExpensesGet extends SrCheckListPageGet {}
export interface SrCheckListExpenseGet extends SrCheckListPageGet, SrCheckListRefundParams {
    expense_date: string;
    note: string;
    expense_amount: string | number;
    nbr_of_pictures: string | number;
    nbr_of_documents: string | number;
}
export interface SrCheckListLdsGet extends SrCheckListPageGet {}
export interface SrCheckListLdGet extends SrCheckListExpenseGet {
    expense_amount_helptext: string;
    ld_signature_sublabel: string;
    ld_signature: string;
    ld_signature_name: string;
}
